
import { get } from '../helpers/api.helper';

export async function getBillsByCustomer(id_customer) {
    try {
        return await get(`contasreceber?cod_cliente=${id_customer}`);
    } catch (error) {
        console.error('[getBillsByCustomer] erro ao processar request');
    }
}

export async function getAll() {
    try {
        return await get(`contasreceber/pendente`);
    } catch (error) {
        console.error('[getBills] erro ao processar request');
    }
}